import serviciosV2Client from "../../../helpers/serviciosV2Client"

const ANALYTICS = "analytics/ventas-sucursal"
const EXPORT_PDF = "export/ventas-sucursal-pdf"
const EXPORT_EXCEL = "export/ventas-sucursal-excel-pro"

const cleanParams = obj =>
  Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== "" && v !== null && v !== undefined),
  )

/**
 * Carga el análisis de ventas con todos los bloques (kpis, métodos pago,
 * productos, cargos, comparativo) usando incluir=todos.
 *
 * @param {object} opts
 * @param {string} opts.nitemisor
 * @param {"mes"|"rango"} opts.modo
 * @param {number} [opts.year]
 * @param {number} [opts.month]
 * @param {string} [opts.fecha_inicio]
 * @param {string} [opts.fecha_hasta]
 * @param {"fecha"|"fechageneracion"} opts.campo_fecha
 */
export const getAnalisisVentas = ({
  nitemisor,
  modo,
  year,
  month,
  fecha_inicio,
  fecha_fin,
  campo_fecha,
}) => {
  const params = { nitemisor, campo_fecha, incluir: "todos" }
  if (modo === "mes") {
    params.year = year
    params.month = month
  } else {
    params.fecha_inicio = fecha_inicio
    params.fecha_fin = fecha_fin
  }
  return serviciosV2Client.get(ANALYTICS, { params: cleanParams(params) })
}

/**
 * Construye los query-params comunes a los export endpoints.
 * Incluye sucursal opcional y campo_fecha (los export legacy lo aceptan
 * o lo ignoran sin romper).
 */
const buildExportParams = ({
  nitemisor,
  modo,
  year,
  month,
  fecha_inicio,
  fecha_fin,
  campo_fecha,
  sucursal,
}) => {
  const params = { nitemisor, campo_fecha }
  if (modo === "mes") {
    params.year = year
    params.month = month
  } else {
    params.fecha_inicio = fecha_inicio
    params.fecha_fin = fecha_fin
    params.mode = "rango"
  }
  if (sucursal) params.sucursal = sucursal
  return cleanParams(params)
}

/**
 * Pide el HTML del PDF para mostrar en preview dentro de un iframe/modal.
 */
export const getPdfHtml = async opts => {
  const response = await serviciosV2Client.get(EXPORT_PDF, {
    params: buildExportParams(opts),
    responseType: "text",
    transformResponse: [data => data],
    headers: { Accept: "text/html" },
  })
  return response.data
}

/**
 * Descarga el Excel. El back devuelve JSON con shape:
 *   { content_type, data: "<base64>", filename, success }
 * También aceptamos variantes anidadas por compatibilidad.
 */
export const descargarExcel = async opts => {
  const response = await serviciosV2Client.get(EXPORT_EXCEL, {
    params: buildExportParams(opts),
  })

  const payload = response.data

  // El base64 puede venir como string en `data` (forma actual del back),
  // o anidado en `data.archivo_base64` / `archivo_base64` / `base64`.
  const base64 =
    (typeof payload?.data === "string" ? payload.data : null) ||
    payload?.data?.archivo_base64 ||
    payload?.archivo_base64 ||
    payload?.base64

  const filename =
    payload?.filename ||
    payload?.data?.filename ||
    `analisis_ventas_${opts.nitemisor}_${new Date().toISOString().split("T")[0]}.xlsx`

  const contentType =
    payload?.content_type ||
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"

  if (!base64) {
    throw new Error("La respuesta del servidor no contiene el archivo Excel.")
  }

  // Decodificar base64 → Uint8Array → Blob
  const binary = atob(base64)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i)
  const blob = new Blob([bytes], { type: contentType })

  const url = URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = url
  link.setAttribute("download", filename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
